import React, { useEffect, useState } from 'react'
import './Projects.css'
import Card from './Card'
import db from './firebase'


const Projects = () => {
    
    const [project, setproject] = useState([]);
    useEffect(() => {
       db.collection('project').onSnapshot(snapshot => {
          
           setproject(snapshot.docs.map(doc => ({
               id: doc.id,
               project: doc.data()
           })));
       })
    }, []);

    return (
        <div className='project'>
            <div className="project__wrapper">

            <div className='home__section'>

                {
                    project.map(({id, project}) => (
                        <Card
                        key={id}
                        src={project.imgurl}
                        title={project.name}
                        url={project.url}
                        />
                    ))
                    }
                   
            </div>
            </div>
        </div>
        
    );
};

export default Projects
